import type { ItemPatchRequest } from '@/common/api/types/items';

export const isParentManagedByIntegration = (item: {
  parentManagedByIntegration?: boolean;
}): boolean => item.parentManagedByIntegration === true;

export const buildUnparentPatch = (): ItemPatchRequest => ({
  parentId: null,
  relativePriority: { type: 'first' },
});
